import { useState, useEffect, useRef } from 'react'
import SliderSlick from 'react-slick'
import { Container, Row, Col, Image, Card, Form, Button, Spinner, Alert } from 'react-bootstrap'
import InputMask from "react-input-mask";
import { GiReceiveMoney } from "react-icons/gi";
import { GrUserAdmin } from "react-icons/gr";
import { FaPeoplePulling } from "react-icons/fa6";
import { FaWhatsapp, FaInstagram, FaFacebook } from "react-icons/fa";
import { MdAlternateEmail } from "react-icons/md";
import ReactGA from 'react-ga4';

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

function App() {
  const [selectedForm, setSelectedForm] = useState(0)
  const formRef = useRef(null)

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [cpf, setCpf] = useState('');
  const [phone, setPhone] = useState('');
  const [condominium, setCondominium] = useState('');
  const [apartments, setApartments] = useState('');
  const [file, setFile] = useState(null);
  const [company, setCompany] = useState('');
  const [position, setPosition] = useState('');
  const [authorization, setAuthorization] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sentSuccessfully, setSentSuccessfully] = useState(false);
  const [error, setError] = useState(true);

  useEffect(() => {
    console.log('Página carregada');
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search
    });
  }, []);

  const handleSelectForm = (formId) => {
    setSelectedForm(formId);

    setName('')
    setEmail('')
    setCpf('')
    setPhone('')
    setCondominium('')
    setApartments('')
    setFile(null)
    setCompany('')
    setPosition('')
    setAuthorization(false)
    setSentSuccessfully(false)
    setError(false)

    setTimeout(() => {
      if (formRef.current) {
        formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  };

  const settingsDiamante = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 3000,
        }
      }
    ]
  }

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 3000,
        }
      }
    ]
  }
  
  const patrocinadoresDiamante = [
    { image: './patrocinadores/1-logo_energia.jpg', description: 'Energia' },
    { image: './patrocinadores/1-logo_leroymerlin.jpg', description: 'Leroy Merlin' },
    { image: './patrocinadores/1-logo_lghabitacional.jpg', description: 'LG Habitacional' },
    // { image: './patrocinadores/1-logo_necta.jpg', description: 'Necta' },
    { image: './patrocinadores/1-logo_spsp.png', description: 'SPSP' },
  ];

  const patrocinadoresOuro = [
    { image: './patrocinadores/2-logo_dara.jpg', description: 'Data' },
    { image: './patrocinadores/2-logo_gsbru.jpg', description: 'GSBRU' },
    { image: './patrocinadores/2-logo_magictintas.jpg', description: 'Magic Tintas' },
    { image: './patrocinadores/2-logo_rconsultoria.jpg', description: 'R Consultoria' },
    { image: './patrocinadores/2-logo_tintasciacollor.jpg', description: 'Tintas Cia Color' },
    { image: './patrocinadores/2-logo_vitiver_sistemasdeseguranca.jpg', description: 'Vitiver Sistemas de Segurança' },
    { image: './patrocinadores/2-logo_viva.jpg', description: 'Viva Tintas' },
  ];

  const patrocinadoresPrata = [
    { image: './patrocinadores/3-logo_bracol.jpg', description: 'Bracol' },
    { image: './patrocinadores/3-logo_decorcolors.jpg', description: 'Decor Colors' },
    { image: './patrocinadores/3-logo_pinturasdecondominios.jpg', description: 'Pinturas de Condomínios' },
    { image: './patrocinadores/3-logo_planetapiscinas.jpg', description: 'Planeta Piscinas' },
    { image: './patrocinadores/3-logo_veroenergia.jpg', description: 'Vero Energia' },
    { image: './patrocinadores/3-logo_aonet.png', description: 'Aonet' },
    { image: './patrocinadores/3-logo_condgo.png', description: 'Condgo' },
  ];

  const patrocinadoresBronze = [
    { image: './patrocinadores/4-logo_agencia_blackstar.jpg', description: 'Agência BlackStar' },
    { image: './patrocinadores/4-logo_atlasschindler.jpg', description: 'Atlas Schindler' },
    { image: './patrocinadores/4-logo_buffet.jpg', description: 'Buffet' },
    { image: './patrocinadores/4-logo_interlume.jpg', description: 'Interlume' },
    { image: './patrocinadores/4-logo_maoforte.jpg', description: 'Mão Forte' },
    { image: './patrocinadores/4-logo_rmaism_arquiteturaeurbanismo.jpg', description: 'RmaisM Arquitetura e Urbanismo' },
    { image: './patrocinadores/4-logo_sistel.jpg', description: 'Sistel' },
    { image: './patrocinadores/4-logo_spl.jpg', description: 'SPL' },
    { image: './patrocinadores/4-logo_yod.jpg', description: 'YOD' },
    { image: './patrocinadores/4-logo_conect.png', description: 'Conect' },
    { image: './patrocinadores/4-logo_construmarques.png', description: 'Construmarques' },
  ];

  const options = [
    {
      id: 1,
      icon: <GrUserAdmin size={80} />,
      text: "SÍNDICOS E ADMINISTRADORES CONDOMINIAIS"
    },
    {
      id: 2,
      icon: <GiReceiveMoney size={80} />,
      text: "PATROCINADORES"
    },
    {
      id: 3,
      icon: <FaPeoplePulling size={80} />,
      text: "ACOMPANHANTES DE SÍNDICOS E PATROCINADORES"
    }
  ];

  const emailValidate = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const cpfValidate = (cpf) => {
    cpf = cpf.replace(/[^\d]+/g, '')
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false

    let soma = 0
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i)
    let resto = 11 - (soma % 11)
    if (resto === 10 || resto === 11) resto = 0
    if (resto !== parseInt(cpf.charAt(9))) return false

    soma = 0
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i)
    resto = 11 - (soma % 11)
    if (resto === 10 || resto === 11) resto = 0
    return resto === parseInt(cpf.charAt(10))
  }

  const phoneValidate = (phone) => {
    return /^\(\d{2}\) \d{5}-\d{4}$/.test(phone)
  }

  const formSindicosValidate = () => {
    if (!name || name.length < 3) {
      const fieldName = document.getElementById('formSindicosName');
      fieldName.focus();
      fieldName.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldName.style.border = '5px solid red';
      return false;
    }

    if (!email || !emailValidate(email)) {
      const fieldEmail = document.getElementById('formSindicosEmail');
      fieldEmail.focus();
      fieldEmail.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldEmail.style.border = '5px solid red';
      return false;
    }

    if (!cpf || !cpfValidate(cpf)) {
      const fieldCpf = document.getElementById('formSindicosCPF');
      fieldCpf.focus();
      fieldCpf.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldCpf.style.border = '5px solid red';
      return false;
    }

    if (!phone || !phoneValidate(phone)) {
      const fieldPhone = document.getElementById('formSindicosPhone');
      fieldPhone.focus();
      fieldPhone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldPhone.style.border = '5px solid red';
      return false;
    }

    if (!condominium || condominium.length < 3) {
      const fieldCondominium = document.getElementById('formSindicosCondominio');
      fieldCondominium.focus();
      fieldCondominium.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldCondominium.style.border = '5px solid red';
      return false;
    }

    if (!apartments || isNaN(apartments) || apartments < 1) {
      const fieldApartments = document.getElementById('formSindicosApartamentos');
      fieldApartments.focus();
      fieldApartments.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldApartments.style.border = '5px solid red';
      return false;
    }

    // if (!file) {
    //   const fieldFile = document.getElementById('formSindicosComprovante');
    //   fieldFile.focus();
    //   fieldFile.scrollIntoView({ behavior: 'smooth', block: 'center' });
    //   fieldFile.style.border = '5px solid red';
    //   return false;
    // }

    if (!authorization) {
      const fieldAuthorization = document.getElementById('formSindicosAuthorization');
      fieldAuthorization.focus();
      fieldAuthorization.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldAuthorization.style.border = '5px solid red';
      return false;
    }

    return true;
  }

  const formPatrocinadoresValidate = () => {
    if (!name || name.length < 3) {
      const fieldName = document.getElementById('formPatrocinadoresName');
      fieldName.focus();
      fieldName.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldName.style.border = '5px solid red';
      return false;
    }

    if (!email || !emailValidate(email)) {
      const fieldEmail = document.getElementById('formPatrocinadoresEmail');
      fieldEmail.focus();
      fieldEmail.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldEmail.style.border = '5px solid red';
      return false;
    }

    if (!cpf || !cpfValidate(cpf)) {
      console.log('cpf invalido')
      const fieldCpf = document.getElementById('formPatrocinadoresCpf');
      console.log(fieldCpf)
      fieldCpf.focus();
      fieldCpf.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldCpf.style.border = '5px solid red';
      return false;
    }

    if (!phone || !phoneValidate(phone)) {
      const fieldPhone = document.getElementById('formPatrocinadoresPhone');
      fieldPhone.focus();
      fieldPhone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldPhone.style.border = '5px solid red';
      return false;
    }

    if (!company || company.length < 3) {
      const fieldCompany = document.getElementById('formPatrocinadoresCompany');
      fieldCompany.focus();
      fieldCompany.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldCompany.style.border = '5px solid red';
      return false;
    }

    if (!position || position < 3) {
      const fieldPosition = document.getElementById('formPatrocinadoresPosition');
      fieldPosition.focus();
      fieldPosition.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldPosition.style.border = '5px solid red';
      return false;
    }

    if (!file) {
      const fieldFile = document.getElementById('formPatrocinadoresComprovante');
      fieldFile.focus();
      fieldFile.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldFile.style.border = '5px solid red';
      return false;
    }

    if (!authorization) {
      const fieldAuthorization = document.getElementById('formPatrocinadoresAuthorization');
      fieldAuthorization.focus();
      fieldAuthorization.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldAuthorization.style.border = '5px solid red';
      return false;
    }

    return true;
  }

  const formAcompanhantesValidate = () => {
    if (!name || name.length < 3) {
      const fieldName = document.getElementById('formAcompanhantesNome');
      fieldName.focus();
      fieldName.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldName.style.border = '5px solid red';
      return false;
    }

    if (!email || !emailValidate(email)) {
      const fieldEmail = document.getElementById('formAcompanhantesEmail');
      fieldEmail.focus();
      fieldEmail.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldEmail.style.border = '5px solid red';
      return false;
    }

    if (!cpf || !cpfValidate(cpf)) {
      const fieldCpf = document.getElementById('formAcompanhantesCPF');
      fieldCpf.focus();
      fieldCpf.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldCpf.style.border = '5px solid red';
      return false;
    }

    if (!phone || !phoneValidate(phone)) {
      const fieldPhone = document.getElementById('formAcompanhantesPhone');
      fieldPhone.focus();
      fieldPhone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldPhone.style.border = '5px solid red';
      return false;
    }

    if (!condominium || condominium.length < 3) {
      const fieldCondominium = document.getElementById('formAcompanhantesCondominio');
      fieldCondominium.focus();
      fieldCondominium.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldCondominium.style.border = '5px solid red';
      return false;
    }

    if (!apartments || isNaN(apartments) || apartments < 1) {
      const fieldApartments = document.getElementById('formAcompanhantesApartamentos');
      fieldApartments.focus();
      fieldApartments.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldApartments.style.border = '5px solid red';
      return false;
    }

    if (!file) {
      const fieldFile = document.getElementById('formAcompanhantesComprovante');
      fieldFile.focus();
      fieldFile.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldFile.style.border = '5px solid red';
      return false;
    }

    if (!authorization) {
      const fieldAuthorization = document.getElementById('formAcompanhantesAuthorization');
      fieldAuthorization.focus();
      fieldAuthorization.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldAuthorization.style.border = '5px solid red';
      return false;
    }

    return true;
  }

  const handleChange = (fn) => (e) => {
    e.target.style.border = '';
    fn(e);
  }

  const uploadFileToS3 = async (file) => {
    const now = new Date();

    const pad = (n: number) => n.toString().padStart(2, '0');

    const date =
      now.getFullYear().toString() +
      pad(now.getMonth() + 1) +
      pad(now.getDate()) +
      pad(now.getHours()) +
      pad(now.getMinutes()) +
      pad(now.getSeconds());

    console.log('name', name)
    const nameFormatted = name.toUpperCase().replace(/\s+/g, '').replace(/[^A-Z0-9_.]/g, '');

    const fileName = `${date}-${nameFormatted}`;

    const res = await fetch(`${process.env.REACT_APP_API}/files/presigned_url/website/${process.env.REACT_APP_WEBSITE_ID}/file/${fileName}/type/${encodeURIComponent(file.type)}`)
    const response = await res.json()
    const { url, fileUrl } = response.data

    const upload = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type
      },
      body: file
    })

    if (upload.ok) {
      console.log('File uploaded successfully', fileUrl)
      return fileUrl
    } else {
      console.error('File upload failed')
      return false
    }
  }

  const sendMail = async (data) => {
    const body = createBody(data)
    const response = await fetch(`${process.env.REACT_APP_API_CONTROLLER}/send-mail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Id': process.env.REACT_APP_WEBSITE_ID,
        'Authorization': `Bearer ${process.env.REACT_APP_API_MAIL_KEY}`
      },
      body: JSON.stringify(body)
    })

    if (response.ok) {
      console.log('Notification sent successfully')
      return true
    } else {
      console.error('Notification sending failed')
      return false
    }
  }

  const createBody = (message) => {
    return {
      'senderName': 'Site Condomínio Nota Dez',
      'sender': 'contato@nois.dev.br',
      'recipientName': 'Condomínio Nota Dez',
      'recipient': 'condominionotadez@outlook.com',
      'title': 'Nova inscrição via site',
      'message': message
    }
  }

  const handleFormSindicos = async (e) => {
    e.preventDefault()

    if (loading) return
    setLoading(true)

    if (!formSindicosValidate()) {
      setLoading(false)
      return
    }

    // const fileUrl = await uploadFileToS3(file);
    // if (!fileUrl) {
    //   console.log('File upload failed')
    //   setLoading(false)
    //   setError(true)
    //   return
    // }

    setError(false)

    const message = `Tipo de inscrição: Síndicos e Administradores Condominiais
      Nome: ${name}
      Email: ${email}
      CPF: ${cpf}
      Celular: ${phone}
      Nome do Condomínio: ${condominium}
      Nº de apartamentos: ${apartments}
    `

    if (!await sendMail(message)) {
      console.log('Notification sending failed')
    }

    setName('');
    setEmail('');
    setCpf('');
    setPhone('');
    setCondominium('');
    setApartments('');
    // setFile(null);
    document.getElementById('formSindicosComprovante').value = null;
    setAuthorization(false);

    setSentSuccessfully(true);      
    setLoading(false);
  }

  const handleFormPatrocinadores = async (e) => {
    e.preventDefault();

    if (loading) return
    setLoading(true)

    if (!formPatrocinadoresValidate()) {
      setLoading(false);
      return
    }

    const fileUrl = await uploadFileToS3(file);
    if (!fileUrl) {
      console.log('File upload failed')
      setLoading(false)
      setError(true)
      return
    }

    setError(false)

    const message = `Tipo de inscrição: Patrocinadores
      Nome: ${name}
      Email: ${email}
      CPF: ${cpf}
      Celular: ${phone}
      Empresa: ${company}
      Cargo: ${position}
      Comprovante: ${fileUrl}
    `

    if (!await sendMail(message)) {
      console.log('Notification sending failed')
    }

    setName('');
    setEmail('');
    setCpf('');
    setPhone('');
    setCompany('');
    setPosition('');
    setFile(null);
    document.getElementById('formPatrocinadoresComprovante').value = null;
    setAuthorization(false);

    setSentSuccessfully(true);
    setLoading(false);
  }

  const handleFormAcompanhantes = async (e) => {
    e.preventDefault()
  
    if (loading) return
    setLoading(true)

    if (!formAcompanhantesValidate()) {
      setLoading(false);
      return;
    }

    const fileUrl = await uploadFileToS3(file);
    if (!fileUrl) {
      console.log('File upload failed')
      setLoading(false)
      setError(true)
      return
    }

    setError(false)

    const message = `Tipo de inscrição: Acompanhantes
      Nome: ${name}
      Email: ${email}
      CPF: ${cpf}
      Celular: ${phone}
      Nome do Condomínio: ${condominium}
      Nº de apartamentos: ${apartments}
      Comprovante: ${fileUrl}
    `

    if (!await sendMail(message)) {
      console.log('Notification sending failed')
    }

    setName('');
    setEmail('');
    setCpf('');
    setPhone('');
    setCondominium('');
    setApartments('');
    setFile(null);
    document.getElementById('formAcompanhantesComprovante').value = null;
    setAuthorization(false);

    setSentSuccessfully(true);
    setLoading(false);
  }

  const renderForm = () => {
    switch (selectedForm) {
      case 1:
        return (
          <Form onSubmit={handleFormSindicos}>
            <Row>
              <Col lg={12} className='d-flex flex-column justify-content-center align-items-center'>
                <GrUserAdmin size={80} />
                <span className='text-center mt-3 mb-3' style={{ display: 'block', fontSize: '22px', fontWeight: 'bold' }}>
                  SÍNDICOS E ADMINISTRADORES CONDOMINIAIS
                </span>
                <span className='text-center mt-3 mb-3'>
                  Síndicos e Subsíndicos tem direito a 1 acompanhante pagando uma taxa de R$90,00
                </span>
                <span className='text-center mt-3 mb-3'>
                  O Comprovante será enviado em seu E-mail!
                </span>
              </Col>
              <Col lg={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Nome completo</Form.Label>
                  <Form.Control
                    id="formSindicosName"
                    type="text"
                    placeholder="Seu nome completo"
                    value={name}
                    onChange={handleChange(e => setName(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={12}>
                <Form.Group className="mb-3">
                  <Form.Label>E-mail</Form.Label>
                  <Form.Control
                    id="formSindicosEmail"
                    type="text"
                    placeholder="Seu e-mail"
                    value={email}
                    onChange={handleChange(e => setEmail(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>CPF</Form.Label>
                  <Form.Control
                    id="formSindicosCPF"
                    as={InputMask}
                    mask='999.999.999-99'
                    placeholder="999.999.999-99"
                    value={cpf}
                    onChange={handleChange(e => setCpf(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Celular</Form.Label>
                  <Form.Control
                    id="formSindicosPhone"
                    as={InputMask}
                    mask='(99) 99999-9999'
                    placeholder="(99) 99999-9999"
                    value={phone}
                    onChange={handleChange(e => setPhone(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={8}>
                <Form.Group className="mb-3">
                  <Form.Label>Nome do Condomínio</Form.Label>
                  <Form.Control
                    id="formSindicosCondominio"
                    type="text"
                    placeholder="Nome do Condomínio"
                    value={condominium}
                    onChange={handleChange(e => setCondominium(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Nº de apartamentos</Form.Label>
                  <Form.Control
                    id="formSindicosApartamentos"
                    type="number"
                    min={1}
                    placeholder="Número de apartamentos"
                    value={apartments}
                    onChange={handleChange(e => setApartments(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={12} style={{ display: 'none', border: '3px solid #ffde59', padding: '10px', borderRadius: '5px', marginBottom: '15px' }}>
                <Row>
                  <Col lg={12} className='mb-2'>
                    <span>Envie um comprovante de participação na diretoria do condomínio (ex: declaração da administradora, declaração de próprio punho informando ser síndico, subsíndico, conselheiro ou ata de eleição)</span>
                  </Col>
                  <Col lg={12}>
                    <Form.Control
                      id="formSindicosComprovante"
                      type="file"
                      onChange={handleChange(e => setFile(e.target.files[0]))}
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg={12} className='mt-3 text-center'>
                <Form.Check
                  id="formSindicosAuthorization"
                  type='checkbox'
                  label='Conforme a lei LGPD autorizo o uso de E-mail e WhatsApp pelos parceiros do evento.'
                  checked={authorization}
                  onChange={handleChange(e => setAuthorization(e.target.checked))}
                />
              </Col>
              <Col lg={12}>
                <Button
                  id="buttonEnviarSindicos"
                  type="submit"
                  disabled={loading}
                  className="w-100 mt-3"
                  style={{ backgroundColor: "#ffde59", color: "#753187", fontWeight: 'bold', border: 'none' }}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      ENVIANDO...
                    </>
                  ) : (
                    "ENVIAR INSCRIÇÃO"
                  )}
                </Button>
                <Alert variant="success" className="mt-3 text-center" style={{ display: sentSuccessfully ? 'block' : 'none' }}>
                  <b>Parabéns!</b> Sua inscrição foi enviada com sucesso!
                </Alert>
                <Alert variant="danger" className="mt-3 text-center" style={{ display: error ? 'block' : 'none' }}>
                  <b>Ops!</b> Ocorreu um erro ao enviar sua inscrição, tente novamente.
                </Alert>
              </Col>
            </Row>
          </Form>
        )

      case 2:
        return (
          <Form onSubmit={handleFormPatrocinadores}>
            <Row>
              <Col lg={12} className='d-flex flex-column justify-content-center align-items-center'>
                <GiReceiveMoney size={80} />
                <span className='text-center mt-3 mb-5' style={{ display: 'block', fontSize: '22px', fontWeight: 'bold' }}>
                  PATROCINADORES
                </span>
                <span className='text-center mt-3 mb-3'>
                  O Comprovante será enviado em seu E-mail!
                </span>
              </Col>
              <Col lg={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Nome completo</Form.Label>
                  <Form.Control
                    id="formPatrocinadoresName"
                    type="text"
                    placeholder="Seu nome completo"
                    value={name}
                    onChange={handleChange(e => setName(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={12}>
                <Form.Group className="mb-3">
                  <Form.Label>E-mail</Form.Label>
                  <Form.Control
                    id="formPatrocinadoresEmail"
                    type="text"
                    placeholder="Seu e-mail"
                    value={email}
                    onChange={handleChange(e => setEmail(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>CPF</Form.Label>
                  <Form.Control
                    id="formPatrocinadoresCpf"
                    as={InputMask}
                    mask='999.999.999-99'
                    placeholder="999.999.999-99"
                    value={cpf}
                    onChange={handleChange(e => setCpf(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Celular</Form.Label>
                  <Form.Control
                    id="formPatrocinadoresPhone"
                    as={InputMask}
                    mask='(99) 99999-9999'
                    placeholder="(99) 99999-9999"
                    value={phone}
                    onChange={handleChange(e => setPhone(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Empresa</Form.Label>
                  <Form.Control
                    id="formPatrocinadoresCompany"
                    type="text"
                    placeholder="Nome da Empresa"
                    value={company}
                    onChange={handleChange(e => setCompany(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Cargo</Form.Label>
                  <Form.Control
                    id="formPatrocinadoresPosition"
                    type="text"
                    placeholder="Seu cargo"
                    value={position}
                    onChange={handleChange(e => setPosition(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={12} style={{ border: '3px solid #ffde59', padding: '10px', borderRadius: '5px', marginBottom: '15px' }}>
                <Row>
                  <Col lg={12} className='mb-2'>
                    <span>Envie um comprovante que faz parte da equipe de colaboradores da empresa</span>
                  </Col>
                  <Col lg={12}>
                    <Form.Control
                      id="formPatrocinadoresComprovante"
                      onChange={handleChange(e => setFile(e.target.files[0]))}
                      type="file"
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg={12} className='mt-3 text-center'>
                <Form.Check
                  id='formPatrocinadoresAuthorization'
                  type='checkbox'
                  label='Conforme a lei LGPD autorizo o uso de E-mail e WhatsApp pelos parceiros do evento.'
                  checked={authorization}
                  onChange={handleChange(e => setAuthorization(e.target.checked))}
                />
              </Col>
              <Col lg={12}>
                <Button
                  id="buttonEnviarPatrocinadores"
                  type="submit"
                  className="w-100 mt-3"
                  style={{ backgroundColor: "#ffde59", color: "#753187", fontWeight: 'bold', border: 'none' }}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      ENVIANDO...
                    </>
                  ) : (
                    "ENVIAR INSCRIÇÃO"
                  )}
                </Button>
                <Alert variant="success" className="mt-3 text-center" style={{ display: sentSuccessfully ? 'block' : 'none' }}>
                  <b>Parabéns!</b> Sua inscrição foi enviada com sucesso!
                </Alert>
                <Alert variant="danger" className="mt-3 text-center" style={{ display: error ? 'block' : 'none' }}>
                  <b>Ops!</b> Ocorreu um erro ao enviar sua inscrição, tente novamente.
                </Alert>
              </Col>
            </Row>
          </Form>
        )

      case 3:
        return (
          <Form onSubmit={handleFormAcompanhantes}>
            <Row>
              <Col lg={12} className='d-flex flex-column justify-content-center align-items-center'>
                <FaPeoplePulling size={80} />
                <span className='text-center mt-3 mb-5' style={{ display: 'block', fontSize: '22px', fontWeight: 'bold' }}>
                  ACOMPANHANTES DE SÍNDICOS E PATROCINADORES
                </span>
                <span className='text-center mt-3 mb-3'>
                  Síndicos e Subsíndicos tem direito a 1 acompanhante pagando uma taxa de R$90,00
                </span>
                <span className='text-center mt-3 mb-3'>
                  O Comprovante será enviado em seu E-mail!
                </span>
              </Col>
              <Col lg={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Nome completo</Form.Label>
                  <Form.Control
                    id="formAcompanhantesNome"
                    type="text"
                    placeholder="Seu nome completo"
                    value={name}
                    onChange={handleChange(e => setName(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={12}>
                <Form.Group className="mb-3">
                  <Form.Label>E-mail</Form.Label>
                  <Form.Control
                    id="formAcompanhantesEmail"
                    type="text"
                    placeholder="Seu e-mail"
                    value={email}
                    onChange={handleChange(e => setEmail(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>CPF</Form.Label>
                  <Form.Control
                    id="formAcompanhantesCPF"
                    as={InputMask}
                    mask='999.999.999-99'
                    placeholder="999.999.999-99"
                    value={cpf}
                    onChange={handleChange(e => setCpf(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Celular</Form.Label>
                  <Form.Control
                    id="formAcompanhantesPhone"
                    as={InputMask}
                    mask='(99) 99999-9999'
                    placeholder="(99) 99999-9999"
                    value={phone}
                    onChange={handleChange(e => setPhone(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={8}>
                <Form.Group className="mb-3">
                  <Form.Label>Nome do Condomínio</Form.Label>
                  <Form.Control
                    id="formAcompanhantesCondominio"
                    type="text"
                    placeholder="Nome do Condomínio"
                    value={condominium}
                    onChange={handleChange(e => setCondominium(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Nº de apartamentos</Form.Label>
                  <Form.Control
                    id="formAcompanhantesApartamentos"
                    type="number"
                    placeholder="Número de apartamentos"
                    value={apartments}
                    onChange={handleChange(e => setApartments(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col lg={12} style={{ border: '3px solid #ffde59', padding: '10px', borderRadius: '5px', marginBottom: '15px' }}>
                <Row>
                  <Col lg={12} className='mb-2 text-center'>
                    <div style={{ fontWeight: 'bold', fontSize: '24px', padding: '10px' }}>
                      <span>Pix para pagamento</span>
                    </div>
                    <div style={{ fontSize: '20px' }}>
                      <span>E-mail: condnotadez@gmail.com</span>
                    </div>
                    <div style={{ fontWeight: 'bold', fontSize: '24px', padding: '10px' }}>
                      <span>Razão Social</span>
                    </div>
                    <div style={{ fontSize: '20px' }}>
                      <span>LG Habitacional Engenharia e Projetos</span>
                    </div>
                    <div className='mt-3' style={{ fontWeight: 'bold', fontSize: '24px', padding: '10px' }}>
                      <span>Envie aqui o comprovante de pagamento da inscrição</span>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <Form.Control
                      id="formAcompanhantesComprovante"
                      type="file"
                      onChange={handleChange(e => setFile(e.target.files[0]))}
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg={12} className='mt-3 text-center'>
                <Form.Check
                  id='formAcompanhantesAuthorization'
                  type='checkbox'
                  label='Conforme a lei LGPD autorizo o uso de E-mail e WhatsApp pelos parceiros do evento.'
                  checked={authorization}
                  onChange={handleChange(e => setAuthorization(e.target.checked))}
                />
              </Col>
              <Col lg={12}>
                <Button
                  id="buttonEnviarAcompanhantes"
                  type="submit"
                  className="w-100 mt-3"
                  style={{ backgroundColor: "#ffde59", color: "#753187", fontWeight: 'bold', border: 'none' }}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      ENVIANDO...
                    </>
                  ) : (
                    "ENVIAR INSCRIÇÃO"
                  )}
                </Button>
                <Alert variant="success" className="mt-3 text-center" style={{ display: sentSuccessfully ? 'block' : 'none' }}>
                  <b>Parabéns!</b> Sua inscrição foi enviada com sucesso!
                </Alert>
                <Alert variant="danger" className="mt-3 text-center" style={{ display: error ? 'block' : 'none' }}>
                  <b>Ops!</b> Ocorreu um erro ao enviar sua inscrição, tente novamente.
                </Alert>
              </Col>
            </Row>
          </Form>
        )

      default:
        return <p className="text-center">Selecione o tipo de inscrição acima.</p>
    }
  }

  return (
    <Container className="py-3" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <div style={{ flex: 1 }}>
        <Row className="justify-content-center mb-3">
          <Col xs={12} md={12} lg={4} className="text-center">
            <Image
              src="logo_condominio_nota_dez_colorido.png"
              alt="Logo Condomínio Nota Dez"
              fluid
              className='rounded'
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xs={12} md={12} lg={12}>
            <Card className="h-100 text-center shadow-sm border-0 tipo-inscricao-card">
              <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                <Card.Text className="fw-bold mt-3">
                  <div className='mb-3' style={{ fontSize: '24px' }}>
                    Um evento para trocar experiências e crescer no mercado condominial!
                  </div>
                  <div>
                    Data: 25/10/2025<br />
                    Horário: Das 08h às 15h<br />
                    Local: Garden Eventos (Antigo Sagae Eventos)
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xs={12} md={12} lg={12}>
            <div className='rounded' style={{ backgroundColor: "#421a4dff", color: "#ffde59" }}>
              <span className="fw-bold text-center" style={{ fontSize: '24px', display: 'block', padding: '10px' }}>
                1 - ESCOLHA O TIPO DE INSCRIÇÃO
              </span>
            </div>
          </Col>
        </Row>

        <Row className="g-3">
          {options.map((opt, idx) => (
            <Col key={idx} xs={12} md={4} lg={4} className='tipo-inscricao'>
              <Card className="h-100 text-center shadow-sm border-0 tipo-inscricao-card" onClick={() => handleSelectForm(opt.id)}>
                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                  {opt.icon}
                  <Card.Text className="fw-bold mt-3">{opt.text}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {selectedForm !== 0 && (
          <>
            <Row className="mt-3 mb-3">
              <Col xs={12} md={12} lg={12}>
                <div className='rounded' style={{ backgroundColor: "#421a4dff", color: "#ffde59" }}>
                  <span className="fw-bold text-center" style={{ fontSize: '24px', display: 'block', padding: '10px' }}>
                    2 - PREENCHA SEUS DADOS
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={3} className='banner-side' style={{ display: 'none' }}>
                <div className='banner-image-01'></div>
              </Col>
              <Col xs={12} md={6} lg={{ offset: 3, span: 6 }} ref={formRef}>
                <div className='rounded formulario-inscricao'>
                  {renderForm()}
                </div>
              </Col>
              <Col lg={3} className='banner-side' style={{ display: 'none' }}>
                <div className='banner-image-02'></div>
              </Col>
            </Row>
          </>
        )}
      </div>

      <Row>
        <Col xs={12} md={12} lg={12} className="mt-3">
          <div className='rounded' style={{ backgroundColor: "#421a4dff", color: "#ffde59" }}>
            <span className="fw-bold text-center" style={{ fontSize: '24px', display: 'block', padding: '10px' }}>
              PATROCINADORES DIAMANTE
            </span>
          </div>
        </Col>

        <Col xs={12} md={12} lg={12} className="mt-3 text-center">
          <SliderSlick {...settingsDiamante}>
            {patrocinadoresDiamante.map((image, i) => (
              <div key={i} className='patrocinadores-item'>
                <img src={image.image} alt={image.description} />
              </div>
            ))}
          </SliderSlick>
        </Col>

        <Col xs={12} md={12} lg={12} className="mt-3">
          <div className='rounded' style={{ backgroundColor: "#421a4dff", color: "#ffde59" }}>
            <span className="fw-bold text-center" style={{ fontSize: '24px', display: 'block', padding: '10px' }}>
              PATROCINADORES OURO
            </span>
          </div>
        </Col>

        <Col xs={12} md={12} lg={12} className="mt-3 text-center">
          <SliderSlick {...settings}>
            {patrocinadoresOuro.map((image, i) => (
              <div key={i} className='patrocinadores-item'>
                <img src={image.image} alt={image.description} />
              </div>
            ))}
          </SliderSlick>
        </Col>

        <Col xs={12} md={12} lg={12} className="mt-3">
          <div className='rounded' style={{ backgroundColor: "#421a4dff", color: "#ffde59" }}>
            <span className="fw-bold text-center" style={{ fontSize: '24px', display: 'block', padding: '10px' }}>
              PATROCINADORES PRATA
            </span>
          </div>
        </Col>

        <Col xs={12} md={12} lg={12} className="mt-3 text-center">
          <SliderSlick {...settings}>
            {patrocinadoresPrata.map((image, i) => (
              <div key={i} className='patrocinadores-item'>
                <img src={image.image} alt={image.description} />
              </div>
            ))}
          </SliderSlick>
        </Col>

        <Col xs={12} md={12} lg={12} className="mt-3">
          <div className='rounded' style={{ backgroundColor: "#421a4dff", color: "#ffde59" }}>
            <span className="fw-bold text-center" style={{ fontSize: '24px', display: 'block', padding: '10px' }}>
              PATROCINADORES BRONZE
            </span>
          </div>
        </Col>

        <Col xs={12} md={12} lg={12} className="mt-3 text-center">
          <SliderSlick {...settings}>
            {patrocinadoresBronze.map((image, i) => (
              <div key={i} className='patrocinadores-item'>
                <img src={image.image} alt={image.description} />
              </div>
            ))}
          </SliderSlick>
        </Col>

        <Col xs={12} md={12} lg={12}className="mt-3">
          <div className='rounded' style={{ backgroundColor: "#421a4dff", color: "#ffde59" }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '15px', gap: '30px' }}>
              <div style={{ cursor: 'pointer' }} onClick={() => window.open('https://api.whatsapp.com/send?phone=5514997459283', '_blank')}>
                <FaWhatsapp size={30} />
              </div>
              <div style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.instagram.com/condominionota.10', '_blank')}>
                <FaInstagram size={30} />
              </div>
              <div style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.facebook.com/share/174Y1D35PP/?mibextid=wwXIfr', '_blank')}>
                <FaFacebook size={30} />
              </div>
              <div style={{ cursor: 'pointer' }} onClick={() => window.open('mailto:condominionotadez@outlook.com')}>
                <MdAlternateEmail size={30} />
              </div>
            </div>
            <div className='text-center' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '15px', gap: '30px' }}>
              Todos os direitos reservados - Agência BlackStar © CNPJ 24.211.183/0001-52
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default App;
